/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface ParamsProps {
  idLead: string | null;
  idTipoEmpreendimento: string | null;
  inicioIntervaloValorImovel: string | null;
  fimIntervaloValorImovel: string | null;
  inicioIntervaloMetragemImovel: number | null;
  fimIntervaloMetragemImovel: number | null;
  quantidadesDormitorios: number[];
  idPrazoEntregaImovel: string | null;
  idsZonasEmpreendimentos: string[];
  idsBairrosEmpreendimentos: string[];
  idsEmpreendimentos: string[];
}

interface Params {
  idLeadCorretor: string;
  body: ParamsProps;
  refetchDataLead: () => void;
}

export function useAlterarPreferencias(props: Params) {
  const registerData = async () => {
    const ALTERAR_PREFERENCIAS = `${leadsWebEnviroment}/commom/leads/alterar-preferencias/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_PREFERENCIAS, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_preferencias"],
    onSuccess: () => {
      toast.success("Preferencias atualizadas com sucesso", {
        autoClose: 10000,
      });
      props.refetchDataLead();
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
